// -*- Mode: rjsx -*-
import React, { useEffect }  from 'react';
import { useDispatch, useSelector } from 'react-redux';


import { selectLiveRequests, loadLive, selectUnclaimedRequests } from '../assistant/queue';


// show the number on the sidebar.
function NavRoot(props) {
    const dispatch = useDispatch();
	const count = useSelector(selectLiveRequests);
	const unclaimedRequests = useSelector(selectUnclaimedRequests);


	useEffect(() => {
		dispatch(loadLive(""));
    }, [dispatch]);

	var nav = $('#admin-nav--live-request-count');
	$("#unclaimed-task-count").html(unclaimedRequests.length);
	nav.html(count.length);
	if(count.length) {
		nav.parent().addClass('alert-state');
	}
	else {
	    nav.parent().removeClass('alert-state');	    
	}
	return null;
}

export default NavRoot;
